export default __webpack_public_path__ + "static/media/promo2.30fc4897.png";